/* eslint-disable import/no-extraneous-dependencies */

import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Educational } from "@swan-admin/swan-web-component";
import DeviceDetails from "../../components/deviceDetails/DeviceDetails";
import CameraPermission from "../../components/cameraPermission/CameraPermission";
import CustomDrawer from "../../components/customDrawer/CustomDrawer";
import { FACE_SCAN, SESSION_STORAGE_KEY, STREAM_SCAN } from "../../vars";
import OnboardingSummary from "../../components/OnboardingSummary";
import useShopType from "../../customHook/useShopType";
import { UserDetailsContext } from "../../context/userDetails";
import { getSessionStorage } from "../../utils/util";
import useIsCustom from "../../customHook/useIsCustom";

function SetupFlow() {
	const {shopDomain,gender} = useContext(UserDetailsContext)
	const [step, setStep] = useState(1);
	const { isMyknitever, isSwanExt } = useShopType();
	const navigate = useNavigate();
	const [showDrawer, setShowDrawer] = useState(true);
	const isCustom = useIsCustom();
	const toggleDrawer = useCallback(() => {
		setShowDrawer(false);
	}, [showDrawer]);
	
	const handleNext =()=>{
		if (getSessionStorage(SESSION_STORAGE_KEY.FACE_SCAN_NOT_DONE)) {
			navigate(FACE_SCAN)
		}else{
			setStep(2)
		}
	}
	
	useEffect(()=>{
     if (shopDomain) {
		if (isMyknitever || isSwanExt) {
			setStep(0)
		}else{
			setStep(1)
		}
	 }
	},[shopDomain,isMyknitever,isSwanExt])

	return (
		<>
			<CameraPermission setShowDrawer={setShowDrawer} />
			<CustomDrawer open={showDrawer} toggleDrawer={toggleDrawer} className="camera-drawer ">
				{step === 0 && <OnboardingSummary onNext={()=>setStep(1)}/>}
				{step === 1 && <DeviceDetails onNext={handleNext} />}
				{step === 2 && <Educational gender={gender} onComplete={()=>navigate(STREAM_SCAN)} isCustom={isCustom}/>}
			</CustomDrawer>
		</>
	
	);
}

export default SetupFlow;
